require('es6-shim');
import biLogger from '@wix/web-bi-logger';
import { userEvents, uouEvents } from './biEvents';
import { sanitizePII } from '@wix/bi-logger-sanitizer';

const ART_STORE_APP_DEF_ID = '147ab90e-91c5-21b2-d6ca-444c28c8a23b';
class ProviderBi {
  biUser;

  init({ instance_id, galleryId, visitor_id, biToken, consentPolicy, location }) {
    const appDefId = this.getAppIdUrlParam(location);
    if (consentPolicy) {
      this.consentPolicy = consentPolicy;
    } else {
      this.consentPolicy = {
        policy: { analytics: true }
      };
    }
    this.initialData = { instance_id, galleryId, visitor_id, biToken, appDefId };
    const defaults = { src: 65, instance_id, biToken };
    this.biUser = biLogger
      .factory({ endpoint: 'photo-users' })
      .updateDefaults(defaults)
      .logger();
    this.biUserOfUser = biLogger
      .factory({ endpoint: 'photo-ugc' })
      .updateDefaults(defaults)
      .withUoUContext({ visitorId: visitor_id })
      .logger();
    return this;
  }

  getAppIdUrlParam(location) {
    try {
      const searchString = location.search.substring(1);
      const params = searchString.split('&');
      const splitParam = param => param.split('=');
      const appDefIdParam = params.find(param => splitParam(param)[0] == 'appDefId');
      if (appDefIdParam) {
        return splitParam(appDefIdParam)[1];
      }
      return ART_STORE_APP_DEF_ID;
    } catch (err) {
      return ART_STORE_APP_DEF_ID;
    }
  }

  log(event, params = {}) {
    if (!this.biUser || !this.biUserOfUser) {
      console.error('biLogger is not initialized');
      return;
    }
    const { policy } = this.consentPolicy;
    if (policy && !policy.analytics) {
      //user consent policy not allowed bi events
      return;
    }
    params.evid = event.evid;
    params.app_id = this.initialData.appDefId;
    try {
      const log = event.type === 'userEvent' ? this.biUser.log(params) : this.biUserOfUser.log(params);
      return log;
    } catch (ex) {
      //swallow exceptions here because we need to continue the actions even if logging fails
      console.warn('BI Failure', ex);
      return Promise.reject();
    }
  }

  licenseQualityToggle(name, type, enabled) {
    this.log(userEvents.licenseQualityToggle, { name, type, value: enabled });
  }

  licenseToggle(name, enabled) {
    this.log(userEvents.licenseToggle, { name, value: enabled });
  }

  licenseQualityPrice(name, type, price) {
    if (price >= 0) {
      this.log(userEvents.licenseQualityPrice, { name, type, price: price * 100 });
    }
  }

  licenseSave() {
    this.log(userEvents.licenseSave);
  }

  navigate(page_name) {
    this.log(userEvents.navigation, { page_name });
  }

  licenseChangeCurrencyClick(currency, origin) {
    this.log(userEvents.licenseChangeCurrencyClick, { currency, origin });
  }

  buySelectLicense(name, type, price) {
    if (this.initialData.visitor_id) {
      this.log(uouEvents.buySelectLicense, { name: name + '__' + type, gallery_id: this.initialData.galleryId });
    }
  }

  addToCart(name, currency, price) {
    if (this.initialData.visitor_id) {
      this.log(uouEvents.addToCart, { name, currency, price: price * 100, gallery_id: this.initialData.galleryId });
    }
  }

  cartCheckout(visitor_id, currency, count, price) {
    if (this.initialData.visitor_id) {
      return this.log(uouEvents.cartCheckout, { currency, count, price: price * 100, name: '' });
    }
  }

  downloadImage(galleryId) {
    if (this.initialData.visitor_id) {
      this.log(uouEvents.downloadImage, { gallery_id: galleryId });
    }
  }

  licenseCreateClick() {
    this.log(userEvents.licenseCreateClick);
  }

  licenseUpload() {
    this.log(userEvents.licenseUpload);
  }

  licenseNewLicenseSave(name, description) {
    this.log(userEvents.licenseNewLicenseSave, { name, description });
  }

  licenseEdit(action) {
    this.log(userEvents.licenseEdit, { action });
  }

  licenseDelete() {
    this.log(userEvents.licenseDelete);
  }

  manageBusinessInfo = this.debounce((field, value, shouldSanitize) => {
    this.log(userEvents.manageBusinessInfo, {
      field,
      value: shouldSanitize ? sanitizePII(value) : value
    });
  }, 500);

  manageAddLogoClick = this.debounce(() => this.log(userEvents.manageAddLogo), 100);

  manageLocale(field, value) {
    this.log(userEvents.manageLocale, { category: field, value });
  }

  manageEmailSettings(value) {
    this.log(userEvents.manageEmailSettings, { value });
  }

  manageLoad() {
    this.log(userEvents.manageLoad);
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
}

export default new ProviderBi();
